function setup(selector) {
  const elements = document.querySelectorAll(selector);
  if (elements) {
    elements.forEach((element) => {
      const inview = new Waypoint.Inview({
        element,
        enter() {
          this.element.classList.add('inview-in');
        },
      });

      return inview;
    });
  }
}

DO.Subscribe('app:ready', () => {
  setup('.inview');
  setup('.inview-caption');
});
